import React, { useContext, useEffect, useRef, useState } from 'react';
import { Field, Form, Formik } from 'formik';
import { useHistory } from 'react-router-dom';
import * as yup from 'yup';
import Row from 'components/Grid/Row';
import Col from 'components/Grid/Col';
import { ButtonContainer, ButtonMiradorOrange } from 'components/Button';
import { ButtonContent } from './styles';

import { FitinsurAPI, MessageCenter } from 'utils';
import Mask from 'utils/src/mask';
import FitFormTolls from 'utils/src/fitinsur-form-tolls';
import Colors from 'constants/Colors';
import { GlobalAuthContext, GlobalLoaderContext, GlobalOperationContext } from 'store/context';
import Loader from 'components/Loader';
import Crypt from "utils/src/crypt";

export default function Page4({ match }) {
  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const operationContext = useContext(GlobalOperationContext);
  const history = useHistory();
  const formikRef = useRef(null);
  const idOperation = match.params.idOperation ? match.params.idOperation : null;
  const [loginState, setLoginState] = useState(false);
  const idProduct = 17;
  const idProductList = [17];
  const [questions, setQuestions] = useState([]);
  const [coverages, setCoverages] = useState([]);
  const fitform = new FitFormTolls();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const crypt = new Crypt();

  const fieldQuestions = {
    CPF: "187",
    email: "188",
    name: "189",
  }
  //redirect
  const goToLoginPage = () => {
    history.push('/login');
  };
  const goBack = () => {
    history.goBack();
  }

  //validação de campo
  const createValidation = () => {
    return yup.object().shape({
      "189": fitform.verifyRequired(fieldQuestions.name, questions)
        ? yup.string().required("* Campo obrigatório")
        : yup.string().notRequired(),
      "188": fitform.verifyRequired(fieldQuestions.email, questions)
        ? yup.string().required("* Campo obrigatório")
        : yup.string().notRequired(),
      "187": fitform.verifyRequired(fieldQuestions.CPF, questions)
        ? yup.string().required("* Campo obrigatório")
        : yup.string().notRequired(),
    });
  }

  const initial = {
    187: "",
    188: "",
    189: "",
    190: "",
    191: "",
    192: "",
    196: "",
    197: "",
    198: "",
    199: "",
    193: "",
    194: "",
    195: "",
    201: "",
    235: "",
  }

  let messageHeader = () => {
    return (
      <><div>
        <h4>
          Planeje sua aposentadoria de verdade
          <br />
          ou invista para conquistar
          <br />
          o que quer no futuro
        </h4>
      </div>
      </>
    );
  }

  const handleSubmit = (values) => {
    loading.start();
    let qstRisk = [];
    let qstPerson = [];
    let qstOperation = [];

    let bodyReq = {
      OptionDeduct: [],
      OptionMaxLim: [],
      add_step: 2,
      coverageListSelected: "",
      firstInstallmentDate: "",
      idDomainPerson: 34,
      idOperation: idOperation ? idOperation : null,
      idPlanCoverage: null,
      idRiskAnswer: [],
      idRiskQuestion: [],
      id_person: 0,
      id_product: idProduct,
      id_product_list: idProductList,
      legalPersonId: null,
      operationQuestionnaire: [],
      paymentMethod: "",
      paymentMode: "",
      paymentQuestionnaire: [],
      personFirstName: null,
      personLastName: null,
      personQuestionnaire: [],
      riskIdQuestionnaire: null,
      riskQuestionnaire: [],
      textRiskAnswer: [],
      formPaymentQuestionnaire: [],
    };

    Object.keys(values).forEach((idQuestion) => {
      const item = questions.find(element => element.idQuestion.toString() === idQuestion);

      let qst = {
        idAnswerOption: Array.isArray(values[idQuestion])
          ? values[idQuestion].map((option) => option.idAnswerOption?.toString())
          : values[idQuestion].idAnswerOption?.toString(),
        idDomainPersonRole: item.idDomainPersonRole,
        idQuestion: Number(idQuestion),
        idQuestionnaire: item.idQuestionnaire,
        questionDomain: item.questionDomain,
        textQuestionAnswer: Array.isArray(values[idQuestion])
          ? values[idQuestion].map((answer) => answer.answerOptionDescription)
          : values[idQuestion].dsAnswerOption
            ? values[idQuestion].dsAnswerOption
            : values[idQuestion],
      };

      if (item.idQuestionnaire === 24) {
        // person questionarie
        if (qst.idQuestion === 187) {
          let unformated = Mask.numbers(qst.textQuestionAnswer);
          qst.textQuestionAnswer = unformated;
        };

        qstPerson.push(qst);
        return;
      }

      if (item.idQuestionnaire === 25) {
        qstRisk.push(qst);
        return;
      }

      if (item.idQuestionnaire === 26) {
        qstOperation.push(qst);
        return;
      }
    })

    bodyReq.operationQuestionnaire = qstOperation;
    bodyReq.riskQuestionnaire = qstRisk;
    bodyReq.personQuestionnaire = qstPerson;

    operationContext.add2_request = bodyReq;

    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestAddAction2(bodyReq)
      .then((response) => response.json())
      .then((data) => {
        if (data.ret_value.id_operation) {

          const addOperation = JSON.parse(localStorage.getItem("fitOperation")).add_response;
          operationContext.add2_response = data;
          operationContext.add2_request["idOperation"] = data.ret_value.id_operation;
          operationContext.add_response = addOperation;
          localStorage.setItem("fitOperation", JSON.stringify(operationContext));
          reqAdd5(data.ret_value.id_operation);
        } else {
          mc.error("Id Operation Not Found!");
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        loading.stop();
      });
  }

  function reqAdd5(idOperation) {
    fitinsur.requestAddAction5(idOperation, null, true)
      .then((response) => response.json())
      .then((data) => {
        if (data.ret_code !== 200) {
          console.log(data.ret_msg);
          mc.error("Erro ao enviar o Código, tente novamente")
          return;
        };
        history.push(`/embed/page5/${idOperation}`);
      })
      .catch((e) => {
        console.log(e);
        loading.stop();
      });
  }

  useEffect(() => {
    function getToken() {
      loading.start();
      // limpa localStorage
      const resetOperation = {
        add2_request: {},
        add2_response: {},
        add_response:{},
        issue_request: [],
        issue_response: [],
      };
      Object.assign(operationContext, resetOperation)
      localStorage.clear();

      fitinsur.requestLoginMirador()
        .then(data => data.json())
        .then(response => {
          console.log("requestLogin - Success:", response);
          authContext.login_response = response;
          if (response.ret_code == "200") {
            authContext.status = true;
            authContext.username = process.env.REACT_APP_USER;
            if (response.ret_token) authContext.token = response.ret_token; // LEGACY LOGIN
            if (response.ret_value.token)
              authContext.token = response.ret_value.token; // LOGIN V2
            authContext.person_product = response.ret_person_product;
            authContext.region = response.ret_value.region;
            authContext.enumProfile = response.ret_value.enumProfile;
            authContext.firstLogin = false;
            if (response.ret_value) {
              authContext.firstLogin = Number(response.ret_value.loginCount) <= 0;
            }

            // armazena contexto-token logado no storage
            localStorage.setItem("session", crypt.encryptJson(authContext));
            fitinsur.setAuthToken(response.ret_value.token);
            fitinsur.requestAddAction(idProduct, [])
              .then(response => response.json())
              .then(data => {
                if (data.ret_code !== 200) {
                  console.log('Erro:', data.json());
                  return;
                };

                const questions = [
                  ...data.ret_value.formPaymentQuestionnaire,
                  ...data.ret_value.personQuestionnaire,
                  ...data.ret_value.riskQuestionnaire,
                  ...data.ret_value.operationQuestionnaire,
                ]
                setQuestions(questions);
                const coverage = [
                  ...data.ret_value.coverages,
                ]
                setCoverages(coverage);
                operationContext.add_response = data.ret_value; 
                localStorage.setItem("fitOperation", JSON.stringify(operationContext));
              });
          } else {
            authContext.status = false;
            authContext.username = process.env.REACT_APP_USER;
            authContext.token = "";
            authContext.person_product = [];
            authContext.user_region = "";
            //Header.subtitle = "Erro ao acessar o sistema";
            console.error("Erro ao acessar o sistema");
            //router.push('/embed/ops');
          };
        })
        .catch((error) => {
          authContext.status = false;
          authContext.username = process.env.REACT_APP_USER;
          authContext.token = "";
          authContext.person_product = [];
          authContext.user_region = "";
          authContext.login_response = "ERROR: " + error.message;
          console.error("requestLogin - Error:", error);
          console.log("Erro ao acessar o sistema");
          //router.push('/embed/ops');
        })
        .finally(() => {
          loading.stop();
        });
    };
    if (!loginState) {
      //Checar retorno a tela para update do questionario
      if (match.params.idOperation) {
        const auxQuestions = [
          ...operationContext.add_response.operationQuestionnaire,
          ...operationContext.add_response.personQuestionnaire,
          ...operationContext.add_response.riskQuestionnaire,
          ...operationContext.add_response.formPaymentQuestionnaire,
        ]
        setQuestions(auxQuestions);
        setLoginState(true)
        return;
      }
      getToken();
      setLoginState(true);
    }
  }, [loginState]);

  return (
    <>
      <Row>
        <Col style={{ display: "flex", justifyContent: "flex-end" }}>
          <button
            onClick={(e) => { e.stopPropagation(); e.preventDefault() }}
            style={{ opacity: 0, width: 0, height: 0 }}>
          </button>
        </Col>

      </Row>
      <Formik
        innerRef={formikRef}
        initialValues={initial}
        validateOnMount={true}
        onSubmit={(values) => handleSubmit(values)}
        validationSchema={createValidation()}
      >
        {({ isValid, setFieldValue }) => (
          <Form>
            <Row style={{ textAlign: "center", justifyContent: "center" }}>{messageHeader()}</Row>
            <Row><hr style={{ width: "100%", boxShadow: "rgba(0, 0, 0, 0.05) 1px 3px 5px 1px" }} /></Row>
            <Row>
              <Col>
                <Field
                  name={fieldQuestions.name}
                  label={fitform.getDsQuestion(fieldQuestions.name, questions)}
                  component={fitform.verifyComponent(fieldQuestions.name, questions)}
                  options={fitform.verifyOptions(fieldQuestions.name, questions)}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Field
                  name={fieldQuestions.CPF}
                  label={fitform.getDsQuestion(fieldQuestions.CPF, questions)}
                  component={fitform.verifyComponent(fieldQuestions.CPF, questions)}
                  options={fitform.verifyOptions(fieldQuestions.CPF, questions)}
                  onChange={(e) => { setFieldValue(fieldQuestions.CPF, Mask.cpf(e)) }}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Field
                  name={fieldQuestions.email}
                  label={fitform.getDsQuestion(fieldQuestions.email, questions)}
                  component={fitform.verifyComponent(fieldQuestions.email, questions)}
                  options={fitform.verifyOptions(fieldQuestions.email, questions)}
                />
              </Col>
            </Row>


            <ButtonContainer style={{ justifyContent: "center" }}>
              <ButtonContent>
                <ButtonMiradorOrange
                  type="submit"
                  primary
                  id="btnSubmit"
                  disabled={!isValid}
                >CONFIRMAR
                </ButtonMiradorOrange>
              </ButtonContent>
            </ButtonContainer>

          </Form>
        )}
      </Formik>
      {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
    </>
  )
}